export default {
  props: {
    label: {},
    title: {},
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      _parent: null
    };
  },
  methods: {
    handleChange: function handleChange() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.model);

        _this.isGroup && _this._parent.$emit('input', _this.model);
      });
    }
  },
  computed: {
    isGroup: function isGroup() {
      if (this.$parent.$options.componentName === 'BaseTabs') {
        this._parent = this.$parent;
        return true;
      } else {
        return false;
      }
    },
    model: {
      get: function get() {
        return this.isGroup ? this._parent.value : this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
        this.isGroup && this._parent.$emit('input', val);
      }
    }
  }
};